export enum ClientDetailTab {
  DATA = 'data',
  CONFIG = 'config',
  PAYMENT = 'payment',
  INFO = 'info',
}
